import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { Button } from "@material-ui/core";
import React from "react";
import { withTranslate } from "react-admin";

const BackButton = ({ translate, ...props }) => {
  const handleClick = () => {
    const sensorOrigin = localStorage.getItem("sensor_origin");
    if (sensorOrigin) {
      window.location.hash = sensorOrigin;
      localStorage.removeItem("sensor_origin");
    } else {
      window.location.hash = "#/sensor";
    }
  };

  return (
    <Button onClick={handleClick} {...props}>
      <ArrowBackIcon /> {translate("ra.action.back")}
    </Button>
  );
};

export default withTranslate(BackButton);
